export const WELOOP_PROJECT_ID = '55f09060-e1b2-11ec-9857-1513f4c24aca';
export const WELOOP_COUNTRY_ID: Record<string, string> = {
  AE: '4e44acc7-2c7b-4d06-9061-cd22cc12d834',
  AT: '8fe6a114-1b89-4d0d-a858-120cbec3b174',
  AU: '770b48a4-f4a6-4599-a551-9d46ed9f0f66',
  BE: '8672a6c9-bfcc-4c76-84cc-2f92903e6191',
  BG: 'edef3896-ec02-4b12-9722-adc15fbecb7e',
  BR: 'c3eb938d-6762-43c2-a2ac-37f887cf2afd',
  CA: 'b481bca4-eeb5-4f51-8bb1-690dfd69ca7a',
  CH: 'c33775cc-085c-4bf6-988e-9f9e18f14cd1',
  CI: '626ccf14-32a3-4e71-b2c7-cb2255b97b82',
  CL: '8575a95c-d311-43b0-988c-b02d7165726b',
  CN: 'da2fd327-0006-4875-8b84-3ab32bcc80ad',
  CO: 'ccde3f1c-a0e4-430c-8cf3-60fff0206cc8',
  CZ: '4096803e-82cd-45b6-9e6d-4fcf511ebc2d',
  DE: 'e17d53ba-f219-458a-87ac-7504ea1ada6c',
  DZ: '15036cfa-762c-4f9b-b5b9-a9c138aad164',
  EE: '2c54278f-9a3e-4cd2-a5f2-8b421cb30c95',
  EG: 'bfdbbeed-40be-442e-a2dc-5dac8a889a65',
  ES: 'e04a7785-0f68-421c-ac12-6a1aaee5b880',
  FR: '68f6dea2-e90c-4d13-8bc2-31859aa8752d',
  GB: 'de14148e-3c9c-455d-9aa2-a40b880be418',
  GP: 'c3009637-2a04-425f-b16c-d3e5004eb55c',
  GR: 'bbcd1d1a-9f29-495a-b943-c62d36901c47',
  HK: '1bdf6b35-75b3-4725-8eaf-dca6b1dc87e7',
  HR: '69db0657-a329-4880-ac2b-b3130ffbcee5',
  HU: 'aa7de398-c536-4b99-b93c-b6af179d2415',
  ID: 'cfc81bfc-3a7b-4f5c-8b8b-de57b70b806f',
  IE: 'ec944d4a-5512-48fd-b1ea-5aa1f7588130',
  IL: '5f186736-91a3-415e-8ffc-3000b7e695dc',
  IN: '1225a4b8-df31-408b-a88a-e4f77876375d',
  IT: '6ea7b411-87dc-451c-9e06-bf75eedfd2b4',
  LT: '06f37461-53e8-4172-889f-aae659a516c3',
  LU: 'f56be557-d6a1-463e-94c0-1e8a812b341a',
  LV: 'e1640dd2-8a5c-4407-9409-ab9c9e8b310b',
  MA: '37a51a0d-5859-4cfa-bcca-003beeb66b68',
  MQ: 'c701fad5-ffcc-4964-8a61-45810e5f5254',
  MT: '8e0c3cbb-a1c5-42d7-80f6-a396d1fd6da3',
  MU: '0d1d3005-e4dc-4812-afac-5c0a44058b2c',
  MX: '322620a2-9fb7-4c4e-8599-a8ea743a02a9',
  MY: 'b533d6ca-4700-4116-9871-2d86f6e2a7e9',
  NC: '947cd345-f6ec-4743-8c53-e08cdd6e702c',
  NL: '403d9c1d-502e-41a5-ab80-581b0f5a737f',
  PA: 'd0a2bd75-3707-42f0-85b4-bf138019f64b',
  PH: 'a7e8e064-b454-4ee6-8556-d8e6d9755381',
  PL: '8ef804a6-ca5a-4308-b012-a7e5284d07b0',
  PT: 'adf78ad9-89bc-479e-b9a4-7bc0e614bf83',
  QA: 'c378ce24-ab44-419a-ae83-f2671b193822',
  RE: '582c5f17-6107-465a-9831-ed19c830210d',
  RO: 'b16c3c8d-936d-4e4c-9d82-3a8b96d148d5',
  RS: '43ebeeb6-f341-4a32-a6a0-897d1998e2d7',
  SA: 'a0edc478-f665-44c1-b913-4fd83e10d3f0',
  SE: 'f3a3f253-b812-4e8e-b2d0-f685fcbdccc8',
  SG: '34fa8e82-4682-47c0-b7b1-a5d2dba23f2c',
  SI: 'e8e87718-9414-4dfc-ad56-294ad3a48108',
  SK: 'c0199840-fc28-45f6-b129-defeb1da2ea0',
  SN: 'f6ee156f-404e-4cbc-91e9-940dbe8ed17e',
  TH: '92ede0bc-9757-4a27-9f66-a28ee6ef3153',
  TN: '7869a72e-029e-4a04-b816-6b1185038a12',
  TR: '820e03d2-2068-41e2-824e-d2cadbc8bb53',
  TW: '834c7e77-7e9b-494e-982d-5d6c961abe71',
  UA: '984e6ee4-a26b-44e4-af23-8688a57bd2ba',
  UY: 'b4eecb21-bbc0-4e06-ab8b-518263f5619d',
  ZA: '571d95f2-3f3a-4c5a-bd51-0476ff266042',
};
